import { STR } from "../i18n.js";
import { useStore } from "../store.js";
import { Field, NumberField, Panel } from "./ui-primitives.js";

export function GFPanel() {
  const { gfLow, gfHigh, lang, setGF } = useStore();
  const t = STR[lang];

  return (
    <Panel title={t.gf}>
      <div className="field-row">
        <Field label={t.gf_low}>
          <NumberField
            value={gfLow}
            min={10}
            max={100}
            step={5}
            suffix="%"
            onChange={(v) => setGF(v, gfHigh)}
          />
        </Field>
        <Field label={t.gf_high}>
          <NumberField
            value={gfHigh}
            min={10}
            max={100}
            step={5}
            suffix="%"
            onChange={(v) => setGF(gfLow, v)}
          />
        </Field>
      </div>
      <div style={{ marginTop: 10, padding: "6px 0" }}>
        <div
          style={{
            position: "relative",
            height: 32,
            background: "var(--bg-input)",
            borderRadius: 4,
            border: "1px solid var(--line)",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              position: "absolute",
              left: `${gfLow}%`,
              right: `${100 - gfHigh}%`,
              top: 0,
              bottom: 0,
              background: "linear-gradient(90deg, var(--caution), var(--accent))",
              opacity: 0.5,
            }}
          />
          <div
            style={{
              position: "absolute",
              left: `${gfLow}%`,
              top: 0,
              bottom: 0,
              width: 2,
              background: "var(--caution)",
              transform: "translateX(-1px)",
            }}
          />
          <div
            style={{
              position: "absolute",
              left: `${gfHigh}%`,
              top: 0,
              bottom: 0,
              width: 2,
              background: "var(--accent)",
              transform: "translateX(-1px)",
            }}
          />
          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "0 6px",
              fontFamily: "var(--font-mono)",
              fontSize: 9,
              color: "var(--ink-3)",
              letterSpacing: "0.1em",
            }}
          >
            <span>0</span>
            <span>50</span>
            <span>100</span>
          </div>
        </div>
        <div
          style={{
            fontFamily: "var(--font-mono)",
            fontSize: 10,
            color: "var(--ink-3)",
            marginTop: 8,
            lineHeight: 1.4,
          }}
        >
          {lang === "fr"
            ? "Bas → premier palier conservateur. Haut → marge en surface."
            : "Low → first stop conservatism. High → surfacing margin."}
        </div>
      </div>
    </Panel>
  );
}
